export class Alert {
    type?: AlertType;
    message?: string;
    isPDF?: boolean;
}

export enum AlertType {
    Success,
    Errors,
    Info,
    Warning
}
